import { render, staticRenderFns } from "./AccentValue.vue?vue&type=template&id=20e2c61c&scoped=true&"
import script from "./AccentValue.vue?vue&type=script&lang=js&"
export * from "./AccentValue.vue?vue&type=script&lang=js&"
import style0 from "./AccentValue.vue?vue&type=style&index=0&id=20e2c61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2c61c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
